export default "__VITE_ASSET__CEam_3QS__"